export default __webpack_public_path__ + "static/media/psydoc1.67259d02.png";